import { Box, Grid } from '../../../imports/muiImport';
import { useState, useSelector } from '../../../imports/generalImport';
import UserDetailPayment from './paymentUtils/UserDetailPayment';
import UserPayButton from './paymentUtils/UserPayButton';
import { useAuth } from '../../../hooks/contexts/AuthContext';
import PaymentOrderReceipt from './paymentUtils/PaymentOrderReceipt';
import PayFromWallet from './paymentUtils/PayFromWallet';
import GiftPromiseCard from './paymentUtils/GiftPromiseCard ';
// import ReferGiftCard from '../../../components/referGiftCard/ReferGiftCard';

function Payment() {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const [walletPayment, setWalletPayment] = useState({
    paymentMethod: null,
    isWalletPayment: false,
  });
  const { isLoggedIn } = useAuth();

  return (
    <Box>
      <PaymentOrderReceipt isWalletAccepted={walletPayment.isWalletPayment} />
      {isLoggedIn && (
        <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
          <UserDetailPayment />
        </Box>
      )}

      <Box
        sx={{
          my: 3,
          border: '1.5px solid',
          borderColor: 'divider',
          borderRadius: 2.5,
          backgroundColor: 'white.main',
          pt: 1,
          pb: 2,
          px: 2,
        }}
      >
        {isLoggedIn && (
          <PayFromWallet walletPayment={walletPayment} setWalletPayment={setWalletPayment} />
        )}

        <UserPayButton isLoggedIn={isLoggedIn} walletPayment={walletPayment} />
      </Box>

      <GiftPromiseCard />
    </Box>
  );
}

export default Payment;
